module.exports = __webpack_public_path__ + "static/wl_tour_square-6038d74cd074074b15c1608cb97dbbc8.jpeg";